
export const ErrorPage = () => {
  return (
    <div>ErrorPage</div>
  )
}
